import { environment } from 'src/environments/environment';
import FontFaceObserver from 'fontfaceobserver';

export class FontsLibrairie {

  static data:any;
  static availableFonts:Array<any>;
  static loadedFonts:Array<any>;

  static defaultFonts: Array<any>;
  static designFonts: Array<any>;
  static allFonts: Array<any>;

  static fontErrors: Array<any>;

  /**
   * Constructor
   */
  constructor() {

  }

  /**
   * Set data
   */
  static setData(data:any) {
    this.defaultFonts = [];
    this.designFonts = [];
    this.loadedFonts = [];
    this.availableFonts = [];
    this.fontErrors = [];
    this.data = data;

    for (var key in this.data.designFonts) {
      if (!this.designFonts[this.data.designFonts[key].css.toUpperCase()]) {
        this.designFonts[this.data.designFonts[key].css.toUpperCase()] = [];
      }
      this.data.designFonts[key].url = environment.ASSETS_SERVER + '/assets/fonts/' + this.data.designFonts[key].url;
      //if(!this.designFonts[this.data.designFonts[key].css.toUpperCase()].find((font:any)=>(font.url == this.data.designFonts[key].url))){
        this.designFonts[this.data.designFonts[key].css.toUpperCase()].push(this.data.designFonts[key]);
      //}
    }

    for (var key in this.data.defaultFonts) {
      if (!this.availableFonts[this.data.defaultFonts[key].css.toUpperCase()]) {
        this.availableFonts[this.data.defaultFonts[key].css.toUpperCase()] = [];
      }
      this.data.defaultFonts[key].url = environment.ASSETS_SERVER + '/assets/fonts/' + this.data.defaultFonts[key].url;
      //if(!this.availableFonts[this.data.defaultFonts[key].css.toUpperCase()].find((font:any)=>(font.url == this.data.defaultFonts[key].url))){
        this.availableFonts[this.data.defaultFonts[key].css.toUpperCase()].push(this.data.defaultFonts[key]);
      //}
    }

    for (var key in this.data.userFonts) {
      if (!this.availableFonts[this.data.userFonts[key].css.toUpperCase()]) {
        this.availableFonts[this.data.userFonts[key].css.toUpperCase()] = [];
      }
      this.data.userFonts[key].url = environment.USER_FONTS_FOLDER + this.data.userFonts[key].url;
      //if(!this.availableFonts[this.data.userFonts[key].css.toUpperCase()].find((font:any)=>(font.url == this.data.userFonts[key].url))){
        this.availableFonts[this.data.userFonts[key].css.toUpperCase()].push(this.data.userFonts[key]);
      //}
    }

  }

  static removeAvailableFont(id: string) {
    id = id.toUpperCase();

    delete this.availableFonts[id];

    console.log("rm "+id, this.availableFonts);
  }


  static addAvailableFont(id: string) {
    id = id.toUpperCase();
    if (!this.availableFonts[id]) {
      this.availableFonts[id] = this.designFonts[id];
    }
  }

  /**
   * Set data
   */
  static loadFont(id:string) {
    id = id.toUpperCase();
    if (this.availableFonts[id]) {
      let fontobservers = [];
      for (var i = 0; i < this.availableFonts[id].length; i++) {
        var css =	"@font-face {\
                  font-family: '"+ this.availableFonts[id][i].css + "';\
                  src: url('"+ this.availableFonts[id][i].url + "') format('truetype');\
                  font-weight: "+ (this.availableFonts[id][i].is_bold || this.availableFonts[id][i].is_italic_bold ? "bold" : "normal") + ";\
                  font-style: "+ (this.availableFonts[id][i].is_italic || this.availableFonts[id][i].is_italic_bold ? "italic" : "normal") + ";\
              }";

        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');

        head.appendChild(style);
        style.type = 'text/css';

        if ((<any>style).styleSheet) {
          // This is required for IE8 and below.
          (<any>style).styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        let obs = new FontFaceObserver(this.availableFonts[id][i].css, {
          weight: (this.availableFonts[id][i].is_bold || this.availableFonts[id][i].is_italic_bold ? "bold" : "normal"),
          style: (this.availableFonts[id][i].is_italic || this.availableFonts[id][i].is_italic_bold ? "italic" : "normal")
        });
        fontobservers.push(obs.load(null, 10000));

      }

      this.loadedFonts[id] = true;
      return Promise.all(fontobservers);
    } else {
      this.fontErrors.push(id);
      this.removeAvailableFont(id);
      // return Promise.resolve();
      return Promise.reject("FONT NOT AVAILABLE : "+id);
    }
  }

  /**
   * get Style
   */
  static getStyle(id:string) {
    var bold = false;
    var italic = false;
    var bolditalic = false;

    id = id.toUpperCase()

    for (var i = 0; i < this.availableFonts[id].length; i++) {
      if (this.availableFonts[id][i].is_bold) {
        bold = true;
      }
      if (this.availableFonts[id][i].is_italic) {
        italic = true;
      }
      if (this.availableFonts[id][i].is_italic_bold) {
        bolditalic = true;
      }
    }
    return { 'bold': bold, 'italic': italic, 'bolditalic': bolditalic };
  }

}
